export default __webpack_public_path__ + "static/media/Icon_Delete.36320cd0.svg";